import { useState, useEffect } from 'react';

interface NavbarProps {
  transparent?: boolean;
}

const navLinks: { label: string; href: string }[] = [];

export default function Navbar({ transparent = true }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const isTransparent = transparent && !scrolled && !mobileOpen;

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        isTransparent
          ? 'bg-transparent py-5'
          : 'bg-white/95 backdrop-blur-md py-3'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 flex items-center justify-between">
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
          className="flex items-center gap-0 group"
        >
          <img
            src="https://storage.readdy-site.link/project_files/732df27f-b232-4dc5-8c9d-bb28540a6b17/f3d5d353-ac27-494a-8a60-72b72915925c_compressed_Logo-sf.webp"
            alt="GOU Abogados"
            className="h-12 md:h-14 w-auto object-contain"
          />
          <span className={`font-heading text-xl font-bold tracking-wide transition-colors duration-500 ${
            isTransparent ? 'text-white' : 'text-[#02443E]'
          }`}>
            GOU <span className="font-light">Abogados</span>
          </span>
        </a>

        <div className="flex items-center gap-8">
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}
            className={`px-5 py-2.5 rounded-full text-sm font-semibold tracking-wide uppercase transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-[1.03] active:scale-[0.97] ${
              isTransparent
                ? 'bg-accent-500 text-white hover:bg-accent-600'
                : 'bg-primary-500 text-white hover:bg-primary-600'
            }`}
          >
            Consultar
          </a>
        </div>
      </div>
    </nav>
  );
}